import React, {useState} from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Button, FormControl, FormLabel, Input, useToast} from "@chakra-ui/react";
import {Header, Title} from "../sheet";
import useFeedback from "../../../utils/use_feedback";
import {useIncreaseSubscriptionPrice} from "../../../api/payments";

const IncreasePriceSheet = styled(({className, currentPrice, onClose}) => {

    const [price, setPrice] = useState(currentPrice);
    const {error, feedbackCh} = useFeedback();

    const toast = useToast();

    const increaseSubscriptionPrice = useIncreaseSubscriptionPrice(feedbackCh);
    const handleSave = async () => {

        if (price < 6.99) {
            toast({
                title: `Sorry, the minimum is $6.99.`,
                status: 'error',
                isClosable: true,
            });
            return;
        } else if (price > 500) {
            toast({
                title: `Sorry, the maximum is $500.00.`,
                status: 'error',
                isClosable: true,
            });
            return;
        }

        try {
            await increaseSubscriptionPrice(price);
            toast({
                title: `Success - thank you!`,
                status: 'success',
                isClosable: true,
            });
            onClose();
            return;
        } catch {}

        toast({
            title: `Something went wrong.`,
            status: 'error',
            isClosable: true,
        });

    };

        return (
            <div className={className}>

                <Header>
                    <Title>Edit Price</Title>
                </Header>

                <p>
                    We appreciate your support.
                </p>
                <p style={{marginTop: 8}}>
                    All contributions over $6.99 per month include Pro.
                </p>

                <FormControl style={{marginTop: 16}}>
                    <FormLabel>Your total monthly contribution</FormLabel>
                    <Input type="number" placeholder={price} value={price} onChange={(e) => setPrice(e.currentTarget.value)}/>
                </FormControl>

                <Button variant="blue" mb={2} mt={6} width={"100%"} onClick={handleSave}>
                    Save
                </Button>
                <Button variant="grey" width={"100%"} onClick={onClose}>
                    Cancel
                </Button>

            </div>
        );
    }
)`
  p {
    font-size: 17px;
  }
`;

export default IncreasePriceSheet;
